/*eslint no-console: ["error", { allow: ["warn", "error"] }] */
/* tslint:disable:no-console */
// import * as Sentry from '@sentry/browser';
import { ErrorLink, onError } from 'apollo-link-error';
import { ServerError } from 'apollo-link-http-common';
import history from 'src/config/browser-history';
import { getAccessToken, isTokenExpired } from 'src/libs/auth';
import { LOGIN_PAGE_ROUTE } from 'src/pages/login';
import { UNAUTHORISED_PAGE_ROUTE } from 'src/pages/unauthorised';

export const errorHandler: ErrorLink.ErrorHandler = ({
  graphQLErrors,
  networkError,
  response,
  operation,
}) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ extensions, message, locations, path }) => {
      const error = `Message: ${message}, Location: ${locations}, Path: ${path}`;
      console.error('[GraphQL error]: ');
      console.error(error);

      // Remove //  Sentry.captureException(error);
      return;
    });
  }

  if (networkError) {
    const error = `[Network error]: ${networkError}`;
    console.error(error);

    if ((networkError as ServerError).statusCode === 401) {
      const route =
        getAccessToken() !== null && isTokenExpired()
          ? LOGIN_PAGE_ROUTE
          : UNAUTHORISED_PAGE_ROUTE;
      history.push(route, { from: history.location });
      return;
    }

    // Remove // Sentry.captureException(error);
  }

  console.error(`[Response]: ${response}`);
  console.error('[Operation]:');
  console.error(
    `Name: ${operation.operationName}, Query: ${operation.query}, Variables: ${operation.variables}, Extensions: ${operation.extensions}`
  );
};

const errorLink = onError(errorHandler);

export default errorLink;
